// @ts-nocheck

import json from './GRFreebetsWon.json';
import image from './GRFreebetsWon.png';

import atlas from '!!raw-loader!./GRFreebetsWon.atlas';

const skins = {
  X1: 'X1',
  X2: 'X2',
  X5: 'X5',
  X10: 'X10',
  X20: 'X20',
};

const animations = {
  ANIMATION: 'animation',
};

export default {
  id: 'GRFreebetsWon',
  skins,
  animations,
  atlas,
  images: {
    'GRFreebetsWon.png': image,
  },
  json,
};
